import { Car } from '../entities/car.entities';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/filter';


export interface RequestBody {
    makes: string[] | null;
    model?: string[] | null;
    body?: string[] | null;
    drivetrain?: string[] | null;
    yearlt?: number | null;
    yeargt?: number | null;
    collisionlt?: number | null;
    collisiongt?: number | null;
    complt?: number | null;
    compgt?: number | null;
    dcpdlt?: number | null;
    dcpdgt?: number | null;
    averagelt?: number | null;
    averagegt?: number | null;
}

export interface PaginatedResponse {
    cars: Car[];
    total: number;
}

export const fetchCars = async (filters: RequestBody, page: number = 1, limit: number = 10): Promise<PaginatedResponse> => {
    try {
        const queryParams = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });

        const response = await fetch(`${API_URL}?${queryParams.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filters),
        });

        if (!response.ok) {
            throw new Error(`Error fetching cars: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch cars:", error);
        return { cars: [], total: 0 };
    }
};
